export function base64ToBlob(base64String: string) {
  try {
    // Split the base64 string into two parts
    const parts = base64String.split(';base64,')

    // Hold the content type of the image
    const imageType = parts[0].split(':')[1]

    // Convert base64 to raw binary data held in a string
    const decodedData = atob(parts[1])

    // Create an array buffer to hold the data
    const arrayBuffer = new ArrayBuffer(decodedData.length)

    // Create a view to manipulate the array buffer
    const uint8Array = new Uint8Array(arrayBuffer)

    // Fill the array buffer with the decoded base64 data
    for (let i = 0; i < decodedData.length; i++) {
      uint8Array[i] = decodedData.charCodeAt(i)
    }

    // Create the blob object with the array buffer and content type
    return new Blob([arrayBuffer], { type: imageType })
  } catch {
    return null
  }
}
